export default `/* Ids Pie Chart Component */
.chart-legend {
  display: flex;
  padding-inline-start: 8px;
  flex-direction: row;
  margin-top: -4px;
  justify-content: flex-start;
  width: inherit;
}
.chart-legend a {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  align-items: center;
  border: 1px solid transparent;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-chart-legend-font-size);
  color: var(--ids-chart-legend-color-text);
  padding-inline-start: 8px;
  padding-inline-end: 8px;
  padding-block-start: 2px;
  padding-block-end: 2px;
  text-decoration: none;
}
.chart-legend a:focus {
  outline: none;
  border-color: var(--ids-color-border-focus);
  box-shadow: var(--ids-shadow-focus);
}
.chart-legend .swatch {
  display: inline-flex;
  margin-inline-end: 8px;
  height: 12px;
  width: 12px;
  pointer-events: none;
}
.chart-legend .swatch.color-1 {
  background-color: var(--ids-chart-color-1);
}
.chart-legend .swatch.color-2 {
  background-color: var(--ids-chart-color-2);
}
.chart-legend .swatch.color-3 {
  background-color: var(--ids-chart-color-3);
}
.chart-legend .swatch.color-4 {
  background-color: var(--ids-chart-color-4);
}
.chart-legend .swatch.color-5 {
  background-color: var(--ids-chart-color-5);
}
.chart-legend .swatch.color-6 {
  background-color: var(--ids-chart-color-6);
}
.chart-legend .swatch.color-7 {
  background-color: var(--ids-chart-color-7);
}
.chart-legend .swatch.color-8 {
  background-color: var(--ids-chart-color-8);
}
.chart-legend .swatch.color-9 {
  background-color: var(--ids-chart-color-9);
}
.chart-legend .swatch.color-10 {
  background-color: var(--ids-chart-color-10);
}
.chart-legend .swatch.color-11 {
  background-color: var(--ids-chart-color-11);
}
.chart-legend .swatch.color-12 {
  background-color: var(--ids-chart-color-12);
}
.chart-legend .swatch.color-13 {
  background-color: var(--ids-chart-color-13);
}
.chart-legend .swatch.color-14 {
  background-color: var(--ids-chart-color-14);
}
.chart-legend .swatch.color-15 {
  background-color: var(--ids-chart-color-15);
}
.chart-legend .swatch.color-16 {
  background-color: var(--ids-chart-color-16);
}
.chart-legend .swatch.color-17 {
  background-color: var(--ids-chart-color-17);
}
.chart-legend .swatch.color-18 {
  background-color: var(--ids-chart-color-18);
}
.chart-legend .swatch.color-19 {
  background-color: var(--ids-chart-color-19);
}
.chart-legend .swatch.color-20 {
  background-color: var(--ids-chart-color-20);
}
.chart-legend .swatch.color-21 {
  background-color: var(--ids-chart-color-21);
}

.ids-chart-container {
  display: flex;
  flex-direction: column;
}
.ids-chart-container.legend-top {
  margin-block-end: 8px;
  flex-direction: column-reverse;
}
.ids-chart-container.legend-top .chart-legend {
  margin-inline-start: 0;
  justify-content: end;
}
.ids-chart-container.legend-right, .ids-chart-container.legend-left {
  flex-direction: row;
}
.ids-chart-container.legend-right .chart-legend, .ids-chart-container.legend-left .chart-legend {
  margin-inline-start: 0;
  flex-direction: column;
  justify-content: center;
}
.ids-chart-container.legend-right .chart-legend a, .ids-chart-container.legend-left .chart-legend a {
  margin-block-end: 8px;
  width: max-content;
}
.ids-chart-container.legend-left {
  flex-direction: row-reverse;
}

.ids-chart-container {
  height: 100%;
  width: 100%;
}
.ids-chart-container.empty {
  flex-direction: column;
}
.ids-chart-container .dot {
  border-color: var(--ids-color-transparent);
  border-style: solid;
  border-radius: 50%;
  display: inline-block;
  border-width: var(--ids-pie-chart-tooltip-dot-size, 0);
  position: absolute;
  height: 0;
  width: 0;
}
.ids-chart-container:not([class*=legend-]) .chart-legend, .ids-chart-container.legend-none .chart-legend {
  display: none;
}

.ids-chart-svg-container {
  min-width: 80px;
}

.ids-pie-chart {
  margin-block-end: var(--ids-space-12);
  height: 100%;
  width: 100%;
}
.ids-pie-chart .slice.color-1:not([fill]) {
  stroke: var(--ids-chart-color-1);
}
.ids-pie-chart .slice.color-2:not([fill]) {
  stroke: var(--ids-chart-color-2);
}
.ids-pie-chart .slice.color-3:not([fill]) {
  stroke: var(--ids-chart-color-3);
}
.ids-pie-chart .slice.color-4:not([fill]) {
  stroke: var(--ids-chart-color-4);
}
.ids-pie-chart .slice.color-5:not([fill]) {
  stroke: var(--ids-chart-color-5);
}
.ids-pie-chart .slice.color-6:not([fill]) {
  stroke: var(--ids-chart-color-6);
}
.ids-pie-chart .slice.color-7:not([fill]) {
  stroke: var(--ids-chart-color-7);
}
.ids-pie-chart .slice.color-8:not([fill]) {
  stroke: var(--ids-chart-color-8);
}
.ids-pie-chart .slice.color-9:not([fill]) {
  stroke: var(--ids-chart-color-9);
}
.ids-pie-chart .slice.color-10:not([fill]) {
  stroke: var(--ids-chart-color-10);
}
.ids-pie-chart .slice.color-11:not([fill]) {
  stroke: var(--ids-chart-color-11);
}
.ids-pie-chart .slice.color-12:not([fill]) {
  stroke: var(--ids-chart-color-12);
}
.ids-pie-chart .slice.color-13:not([fill]) {
  stroke: var(--ids-chart-color-13);
}
.ids-pie-chart .slice.color-14:not([fill]) {
  stroke: var(--ids-chart-color-14);
}
.ids-pie-chart .slice.color-15:not([fill]) {
  stroke: var(--ids-chart-color-15);
}
.ids-pie-chart .slice.color-16:not([fill]) {
  stroke: var(--ids-chart-color-16);
}
.ids-pie-chart .slice.color-17:not([fill]) {
  stroke: var(--ids-chart-color-17);
}
.ids-pie-chart .slice.color-18:not([fill]) {
  stroke: var(--ids-chart-color-18);
}
.ids-pie-chart .slice.color-19:not([fill]) {
  stroke: var(--ids-chart-color-19);
}
.ids-pie-chart .slice.color-20:not([fill]) {
  stroke: var(--ids-chart-color-20);
}
.ids-pie-chart .slice.color-21:not([fill]) {
  stroke: var(--ids-chart-color-21);
}
.ids-pie-chart.hidden {
  display: none;
}
.ids-pie-chart.selectable .audible {
  font-size: 1px;
}
.ids-pie-chart.selectable .slice {
  cursor: pointer;
}
.ids-pie-chart.selectable .slice[selected] {
  opacity: 1;
}
.ids-pie-chart.selectable .slice.not-selected {
  opacity: 0.5;
}

.slice {
  outline: none;
  fill-opacity: 0;
}

.donut-text {
  font-family: var(--ids-chart-pie-font-family);
  font-size: var(--ids-chart-pie-font-size);
  fill: var(--ids-chart-pie-color-text);
  text-anchor: middle;
}

.donut-hole {
  pointer-events: none;
}

.audible {
  opacity: 0;
  fill-opacity: 0;
}

.chart-legend {
  justify-content: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
